import { Satisfaction } from 'lib-shared-legacy-types';

export namespace DixaMessengerCSAT {
  export const defaultLanguage = 'en';

  export interface Language {
    isSetup: boolean;
    ratingStyle?: Satisfaction.RatingStyle;
    enabled: boolean;
    name: string;
    code: string;
    settings: Satisfaction.DixaMessengerCsatSettings | null;
  }

  export interface MessengerListSetting {
    id: string;
    name: string;
    enabled: boolean;
    settings: Satisfaction.DixaMessengerCsatSettings | null;
  }

  export interface MessengerStatusChange {
    id: string;
    newStatus: boolean;
    settings: Satisfaction.DixaMessengerCsatSettings | null;
  }

  export interface LanguageCustomizationStatusChange {
    language: Language;
    newStatus: boolean;
  }
}
